angular.module('impactx.MenuDirectives').controller('LogoutCtrl', LogoutCtrl);

LogoutCtrl.$inject = ['$scope',
    '$rootScope',
    'dataGen',
    '$location',
    '$route',
    '$context',
    '$securityManager',
    'basketTemplateMenu',
    'searchFilter',
    '$workspace',
    'LoginService',
    'cookieService',
    'DeeplinkService',
    'TranslationService',
    'ReloginExternalService',
    '$listCache',
    'ThemeWorldService',
    'LogoutTimerService',
    'CubeConfigService',
    'ShopViewService',
    'CustomerService',
    '$config',
    'sidebarShow',
    'RFQSearchService',
    '$window',
];

function LogoutCtrl($scope, $rootScope, dataGen, $location, $route, $context, $securityManager, basketTemplateMenu, searchFilter,
                    $workspace, LoginService, cookieService, DeeplinkService, TranslationService, ReloginExternalService, $listCache, ThemeWorldService,
                    LogoutTimerService, CubeConfigService, ShopViewService, CustomerService, $config, sidebarShow, RFQSearchService, $window) {
    var self = this;

    self.logout = function (noRedirect, doExternalLogout) {
        LogoutTimerService.clearLogoutTimer();
        ThemeWorldService.deactivateActiveThemeWorldSearch(false);
        ShopViewService.deactivateShopView(false);
        RFQSearchService.deactivateRFQSSearch(false);
        RFQSearchService.deactivateRFQHSearch(false);
        CustomerService.closePanel();
        searchFilter.searchInputGlobal = '';

        return dataGen.getData($scope, {smallMenuWasShown : !sidebarShow.isOpen(), doExternalLogout: doExternalLogout}, "/logout", null, false, true).then(function (data) {
            if (data && data.data && data.data.form) {
                LogoutTimerService.clearLogoutTimer();
                $listCache.removeAll();
                searchFilter.wasInitialized = false;
                searchFilter.deleteSearchFilterData();
                if (!$context.loginToLastWorkspace) {
                    $workspace.removeWorkspaceCookie();
                }
                $workspace.getCurrentWorkspaceId().value = '';
                $securityManager.invalidate();
                $scope.data = null;
                $context.reset();
                basketTemplateMenu.clearData();
                DeeplinkService.deleteRecentDeeplink();
                CubeConfigService.deleteCache();
                TranslationService.reset(dataGen);

                document.getElementsByTagName("body")[0].innerHTML = data.data.form;
                $("form#externalLogout").submit();
            }
            else {
                if (!data || !data.data || !data.data.reLogin) {
                    LogoutTimerService.clearLogoutTimer();
                    $listCache.removeAll();
                    searchFilter.wasInitialized = false;
                    searchFilter.deleteSearchFilterData();
                    if (!$context.loginToLastWorkspace) {
                        $workspace.removeWorkspaceCookie();
                    }
                    $workspace.getCurrentWorkspaceId().value = '';
                    $securityManager.invalidate();
                    $scope.data = null;
                    $context.reset();
                    basketTemplateMenu.clearData();
                    DeeplinkService.deleteRecentDeeplink();
                    CubeConfigService.deleteCache();
                    TranslationService.reset(dataGen);

                    if (!noRedirect) {
                        if (data && data.data && data.data.logoutURL) {
                            $window.location.href = data.data.logoutURL;
                        }
                        else {
                            self.redirectToLogin();
                        }
                    }
                }
                else {
                    TranslationService.refresh(dataGen);
                    $securityManager.invalidateProcesses();
                    LoginService.refreshUI(true);
                }
            }
            $rootScope.$broadcast('logoutSuccess');
        });

    };

    self.redirectToLogin = function () {
        var loginPageCookie = cookieService.getCookieValue('loginPage');
        if ($location.path() == $config.loginRoute) {
            $location.search({});
            $route.reload();
        }
        else {
            if (ReloginExternalService.isExternalUser()) {
                $location.url('/relogin.external');
            }
            else if (loginPageCookie) {
                $location.url($config.customLoginRoute + '/' + loginPageCookie);
            }
            else {
                $location.url($config.loginRoute);
            }
        }
    };

    $scope.logout = self.logout;
}
